<!--begin::Heading-->
<div class="text-center pb-3">
  <img src="./assets/media/logos/free_float_platform_logo.png" alt="FF Logo" height="45" />
</div>
<div class="mb-10">
  <h3>Set a new password</h3>
  <p class="mb-4 text-body-tertiary">Enter your new account password.</p>
</div>
<!--end::Heading-->
<form
  class="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
  novalidate="novalidate"
  id="kt_login_signup_form"
  [formGroup]="resetPasswordForm"
  (ngSubmit)="submit()">


  <!-- begin::Alert error-->
  <ng-container *ngIf="errorState === errorStates.HasError">
    <div class="mb-lg-15 alert alert-danger">
      <div class="alert-text font-weight-bold">
        Sorry, looks like there are some errors detected, please try again.
      </div>
    </div>
  </ng-container>
  <!-- end::Alert error-->

  <ng-container *ngIf="errorState === errorStates.NoError">
    <div class="mb-10 bg-light-info p-8 rounded">
      <!--begin::Body-->
      <div class="text-info">Password set! Please wait ...</div>
      <!--end::Body-->
    </div>
  </ng-container>

  <!--begin::Form group-->
  <div class="fv-row mb-7">
    <input
      class="form-control form-control-lg form-control-solid mt-4"
      type="email"
      placeholder="Email"
      name="email"
      formControlName="email"
      [ngClass]="{
        'is-invalid': resetPasswordForm.controls['email'].invalid && resetPasswordForm.controls['email'].dirty,
        'is-valid': resetPasswordForm.controls['email'].valid
      }" />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Email is required',
        control: resetPasswordForm.controls['email']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'email',
        message: 'Email is invalid',
        control: resetPasswordForm.controls['email']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Email should have at least 3 symbols',
        control: resetPasswordForm.controls['email']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Email should have maximum 360 symbols',
        control: resetPasswordForm.controls['email']
      }"></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="mb-10 fv-row">
    <input
      class="form-control form-control-lg form-control-solid  mt-4"
      type="password"
      placeholder="Password"
      name="password"
      formControlName="password"
      [ngClass]="{
        'is-invalid': resetPasswordForm.controls['password'].invalid && resetPasswordForm.controls['password'].dirty,
        'is-valid': resetPasswordForm.controls['password'].valid
      }" />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Password is required',
        control: resetPasswordForm.controls['password']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Password should have at least 8 characters',
        control: resetPasswordForm.controls['password']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Password should have maximum 100 characters',
        control: resetPasswordForm.controls['password']
      }"></ng-container>
  </div>
  <!--end::Form group-->

  <!--begin::Form group-->
  <div class="fv-row">
    <input
      class="form-control form-control-lg form-control-solid mt-4"
      type="password"
      placeholder="Confirm password"
      name="password_confirmation"
      formControlName="password_confirmation"
      [ngClass]="{
        'is-invalid': resetPasswordForm.controls['password_confirmation'].invalid && resetPasswordForm.controls['password_confirmation'].dirty,
        'is-valid': resetPasswordForm.controls['password_confirmation'].valid
      }" />
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Confirm Password is required',
        control: resetPasswordForm.controls['password_confirmation']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Confirm Password should have at least 8 characters',
        control: resetPasswordForm.controls['password_confirmation']
      }"></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Confirm Password should have maximum 100 characters',
        control: resetPasswordForm.controls['password_confirmation']
      }"></ng-container>
    <ng-container
      *ngIf="
        resetPasswordForm.controls['password_confirmation'].errors &&
        resetPasswordForm.controls['password_confirmation'].errors['ConfirmPassword']
      ">
      <div class="fv-plugins-message-container">
        <div class="fv-help-block">
          'Passsword' and 'Confirm Password' didn't match.
        </div>
      </div>
    </ng-container>
  </div>
  <!--end::Form group-->


  <!--begin::Form group-->
  <div class="text-center mt-4">
    <button
      type="submit"
      id="kt_sign_up_submit"
      [disabled]="resetPasswordForm.invalid"
      class="btn btn-lg btn-primary w-100 mb-5">
      <ng-container *ngIf="(isLoading$ | async) === false">
        <span class="indicator-label">Change Password</span>
      </ng-container>
      <ng-container *ngIf="isLoading$ | async">
        <span class="indicator-progress" [style.display]="'block'">
          Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"></span>
        </span>
      </ng-container>
    </button>
  </div>
  <!--end::Form group-->
</form>

<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation">
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        <span role="alert">
          {{ message }}
        </span>
      </div>
    </div>
  </ng-container>
</ng-template>
